import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../components/layout/PageContainer/PageContainer';
import { RestaurantCard } from '../../components/features/RestaurantCard/RestaurantCard';
import { restaurants, heroImages } from '../../data/mockData';
import { useUIStore } from '../../stores/uiStore';

export const DineInPage: React.FC = () => {
  const { t } = useTranslation();
  const { openModal } = useUIStore();
  return (
    <PageContainer
      heroImage={heroImages.dineIn}
      heroHeight="small"
      heroTitle={t('dineIn.title')}
      heroSubtitle={t('dineIn.subtitle')}
      overlayOpacity={0.45}
    >
      {/* Restaurant Cards */}
      <div className="space-y-6">
        {restaurants.map((restaurant) => (
          <RestaurantCard
            key={restaurant.id}
            id={restaurant.id}
            name={restaurant.name}
            cuisine={restaurant.cuisine}
            images={restaurant.images}
            description={restaurant.description}
            onViewMenu={() => openModal('restaurant-menu', { name: restaurant.name, cuisine: restaurant.cuisine })}
          />
        ))}
      </div>
    </PageContainer>
  );
};

export default DineInPage;
